// Based on

// Turn off max-len for the file given the comment has a long URL
// eslint-disable max-len

// Note: Below is Yang's original URL validator, based on the link at https://gist.github.com/rodneyrehm/8013067
//       but adapted to allow for other protocols (e.g. x-callbacks, Ulysses, etc).
// Unfortunately, it was causing a hang on this particular string:
//   https://hansard.parliament.uk/Commons/18xx-xx-xx/debates/d0f0bgg87-3adb-4719-aa6c-3238969cf46c4/xxxxxxxxxxxxxxxxxxxxxxx%E2%80%94xxxxxxxxxxxxxxxxx%E2%80%94Question?highlight=xxxxxx#contribution-2f9095d6-a553-4996-8f45-4e1e045384d9
// So I have stripped it back to an easier version shown below

// const URL_REG_EXP = /^(\S+:?\/?)?\/\/?([^\s\/?\.#]+\.?)+(\/[^\s]*)?(\?([^\s\/?\.#]+=[^\s\/?\.#]+)?)?$/i;

// Simpler version: Checks for optional protocol, a basic domain (some data), and then gives it free reign after that
// eslint-disable-next-line no-useless-escape
const URL_REG_EXP = /^(\S+:?\/?)?\/\/?([^\s\/?\.#]+\.?)+(\S+)$/;

export default URL_REG_EXP;
